import React from "react";
import { DataTable } from "../widgets";
import PickedListRow from "./PickedListRow";
import { capitalize } from "../../helpers/common";

const PickedListTable = (props) => {
  const { weightShortName, loadTripList } = props;
  let serialNumber = 0;

  return (
    <DataTable className="mt-2">
      <DataTable.Header>
        <DataTable.Row>
          <DataTable.Cell width="40px">#</DataTable.Cell>
          <DataTable.Cell className="sort-column">
            Transload Site
          </DataTable.Cell>
          <DataTable.Cell className="sort-column">Transport EG</DataTable.Cell>
          <DataTable.Cell className="sort-column">
            Transport EG Operator
          </DataTable.Cell>
          <DataTable.Cell className="sort-column">Trailer</DataTable.Cell>
          <DataTable.Cell className="sort-column">
            Load Weight({weightShortName && capitalize(weightShortName)})
          </DataTable.Cell>
          <DataTable.Cell className="sort-column">Picked Date</DataTable.Cell>
          <DataTable.Cell className="sort-column">Source EG</DataTable.Cell>
          <DataTable.Cell className="sort-column">Target EG</DataTable.Cell>
          <DataTable.Cell className="sort-column">Load Time</DataTable.Cell>
          <DataTable.Cell className="sort-column">Load Status</DataTable.Cell>
        </DataTable.Row>
      </DataTable.Header>
      <DataTable.Body>
        {loadTripList.map((item, index) => {
          if (item) serialNumber++;
          return (
            <PickedListRow
              key={index}
              load={item}
              serialNumber={serialNumber}
            />
          );
        })}
      </DataTable.Body>
    </DataTable>
  );
};

export default PickedListTable;